// deprecated
export const getOption = (obj, name) => {
  const option = obj.options.find((o) => o.name === name);
  if (option) {
    try {
      return JSON.parse(option.value);
    } catch (e) {
      return option.value;
    }
  }
  return null;
};

/* */
export const getUserInitials = (firstname, lastname) => (firstname && lastname ? `${firstname[0]}${lastname[0]}`.toUpperCase() : '');

/* */
export const match = (account, golf) => (account && golf ? account.matches[golf.id] : {});

/* */
export const isMember = (account, golf) => {
  const m = match(account, golf);
  return m && m.isMember;
};

export const getPaymentMethods = (account, golf, module = null) => {
  const golfPaymentMethods = golf.options.paymentMethods;
  const accountType = isMember(account, golf) ? 'member' : 'visitor';

  if (module && golfPaymentMethods.modules && golfPaymentMethods.modules[module]) {
    return golfPaymentMethods.modules[module][accountType];
  }

  return golfPaymentMethods[accountType];
};

/* */
export const golfOptionActivities = (golf) => golf && golf.options
  && golf.options.activities && Object.keys(golf.options.activities).length;
